export class LoadOrders {
  static readonly type = '[Orders] LoadOrders';
  constructor(
    public pageIndex: number,
    public itemsToTake: number
  ) {}
}
